var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css, keyframes } from 'styled-components';
import breakpoint from 'Styles/breakpoints';
import { RowBase } from '../../../RowBase/RowBase.styled';
var revealAnimation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from { opacity: 0; transform: translateY(24px); }\n  to { opacity: 1; transform: translateY(0); }\n"], ["\n  from { opacity: 0; transform: translateY(24px); }\n  to { opacity: 1; transform: translateY(0); }\n"])));
var fadeIn = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  from { opacity: 0; }\n  to { opacity: 1; }\n"], ["\n  from { opacity: 0; }\n  to { opacity: 1; }\n"])));
var applyShadow = function (withShadow) {
    return withShadow
        ? "\n        box-shadow: -3px 10px 20px 0px rgba(3, 3, 2, 0.05),\n          0px 0px 6px 0px rgba(3, 3, 2, 0.05);\n      "
        : '';
};
var paddingSizes = {
    X_MINI: '10px',
    MINI: '10px',
    REGULAR: '18px',
    MEGA: '32px'
};
var maxWidthSizes = {
    X_MINI: '118px',
    MINI: '118px',
    REGULAR: '152px',
    MEGA: '224px'
};
var fontSizeSizes = {
    X_MINI: '14px',
    MINI: '14px',
    REGULAR: '16px',
    MEGA: '16px'
};
var sizeOrder = ['SMALL', 'MEDIUM', 'LARGE'];
var applyResponsiveStyles = function (responsiveSizes, styleProperty, sizes, styleQueryMode) {
    return sizeOrder
        .map(function (screenSize) {
        var style = responsiveSizes.find(function (s) { return s.screenSize === screenSize; });
        if (!style)
            return '';
        var breakpointCss = style.screenSize !== 'SMALL'
            ? breakpoint(style.screenSize.toLowerCase(), {
                mode: styleQueryMode
            })
            : '';
        var rawValue = sizes[style.textSize] || sizes.REGULAR;
        var paddingStyles = "40px ".concat(rawValue, " calc(2% + 40px)");
        var stylePropertiesValues = {
            padding: paddingStyles,
            'max-width': rawValue,
            'font-size': rawValue
        };
        var value = stylePropertiesValues[styleProperty];
        return "\n        ".concat(breakpointCss, " {\n          ").concat(styleProperty, ": ").concat(value, ";\n        }\n      ");
    })
        .filter(Boolean);
};
export var CardOverlay = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: var(--background);\n  color: var(--foreground);\n  border: 6px solid var(--border);\n  position: relative;\n\n  ", "\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: var(--background);\n  color: var(--foreground);\n  border: 6px solid var(--border);\n  position: relative;\n\n  ", "\n  ", "\n"])), function (_a) {
    var withShadow = _a.withShadow;
    return applyShadow(withShadow);
}, function (_a) {
    var _b = _a.responsiveSizes, responsiveSizes = _b === void 0 ? [{ screenSize: 'SMALL', textSize: 'MEGA' }] : _b, $styleQueryMode = _a.$styleQueryMode;
    return applyResponsiveStyles(responsiveSizes, 'padding', paddingSizes, $styleQueryMode);
});
export var CloseButton = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: none;\n  border: none;\n  color: var(--foreground);\n  cursor: pointer;\n  align-self: flex-start;\n  animation: ", " 500ms cubic-bezier(0.25, 1, 0.5, 1);\n  position: absolute;\n  top: 12px;\n  right: 12px;\n"], ["\n  background: none;\n  border: none;\n  color: var(--foreground);\n  cursor: pointer;\n  align-self: flex-start;\n  animation: ", " 500ms cubic-bezier(0.25, 1, 0.5, 1);\n  position: absolute;\n  top: 12px;\n  right: 12px;\n"])), fadeIn);
export var CTAs = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  animation: ", " 500ms cubic-bezier(0, 0.5, 0.1, 1);\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  ", " {\n    & > div > p {\n      ", "\n    }\n  }\n\n  ", "\n  ", "\n"], ["\n  animation: ", " 500ms cubic-bezier(0, 0.5, 0.1, 1);\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  ", " {\n    & > div > p {\n      ", "\n    }\n  }\n\n  ", "\n  ", "\n"])), revealAnimation, RowBase, function (_a) {
    var _b = _a.responsiveSizes, responsiveSizes = _b === void 0 ? [{ screenSize: 'SMALL', textSize: 'REGULAR' }] : _b, $styleQueryMode = _a.$styleQueryMode;
    return applyResponsiveStyles(responsiveSizes, 'font-size', fontSizeSizes, $styleQueryMode);
}, function (_a) {
    var verticallyCentered = _a.verticallyCentered;
    return verticallyCentered && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      flex: 1;\n      justify-content: center;\n      margin-top: 0;\n    "], ["\n      flex: 1;\n      justify-content: center;\n      margin-top: 0;\n    "])));
}, function (_a) {
    var _b = _a.responsiveSizes, responsiveSizes = _b === void 0 ? [{ screenSize: 'SMALL', textSize: 'REGULAR' }] : _b, $styleQueryMode = _a.$styleQueryMode;
    return applyResponsiveStyles(responsiveSizes, 'max-width', maxWidthSizes, $styleQueryMode);
});
export default {};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
